// Colocated strings for TotalAndAssignedCards (SKILL.md rule 11, PACKAGING_PLAN §3.2).
// Consumed by ../setup.js as `useComponentI18n(messages)` from `@rdrive/i18n`, i.e. a LOCAL
// composer with the warn flags off: these keys resolve here and never touch the app's bundle.
//
// Lifted verbatim from the app's `src/locales.js` (same names, top level) when the component
// moved into @rdrive/ui (2026-09-30). All six exist in all 10 bundles there.
// `total` (the spark row's first label, opt-in `sparklines`) joined on 2026-10-07 with
// issue-analysis's values (IA_ABSORPTION_PLAN Phase 4 step 13) — equal, in all 10 locales, to
// @rdrive/vocabulary's `total`, which this local copy shadows (a package never reads the vocabulary).
//
// NOT here, on purpose: the "open items only" tooltip. The template asks for
// `totalOpenItemsToolTip` (capital T), a key that exists in NO bundle — the app's
// `src/locales/*.json` spell it `totalOpenItemsTooltip` — so it misses both scopes and renders the
// raw key, exactly as it did before the move. Fixing the spelling is a behaviour change and
// its own ticket: rename the template key and lift the ten translations in here.
import de from './de.json';
import en from './en.json';
import fr from './fr.json';
import it from './it.json';
import nl from './nl.json';
import pl from './pl.json';
import ptBR from './pt-BR.json';
import th from './th.json';
import vi from './vi.json';
import zhHans from './zh-Hans.json';
import zhHant from './zh-Hant.json';

export default {
  de,
  en,
  fr,
  it,
  nl,
  pl,
  'pt-BR': ptBR,
  th,
  vi,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
};
